/**
 * Small component showing application version from version.json.
 */
import styled from "styled-components";
import versionInfo from "../../../version.json";
import { Typography, Box } from "@mui/material";

const Version = styled.div`
  right: 0;
  text-align: right;
`;

const VersionComponent = () => {
  return (
    <Version>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#ffffff",
          paddingBottom: "20px",
        }}
      >
        <Typography sx={{ fontSize: "12px" }}>
          {"V." + versionInfo.version}{" "}
        </Typography>
        <Typography sx={{ fontSize: "12px" }}>{versionInfo.buildDate}</Typography>
      </Box>
    </Version>
  );
};

export default VersionComponent;
